import { render, staticRenderFns } from "./DataDetailView.vue?vue&type=template&id=68e55170&scoped=true"
import script from "./DataDetailView.vue?vue&type=script&lang=js"
export * from "./DataDetailView.vue?vue&type=script&lang=js"
import style0 from "./DataDetailView.vue?vue&type=style&index=0&id=68e55170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e55170",
  null
  
)

export default component.exports